var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Customize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 17.93l-25.29 30.8C36.64 48.66 31 44.1 30.9 44l25.25-30.82a2.83 2.83 0 014-.39L61.56 14a2.82 2.82 0 01.44 3.93zM34.84 50.5l-5.37-4.34A1.999 1.999 0 1027 49.28l5.37 4.34a2 2 0 001.25.44 2 2 0 001.26-3.56h-.04zm-10.53 1a6.47 6.47 0 00-5.85 4.08c-.25.61-.48 1.55-.77 2.47-1.09 3.47-2.18 2.44-2.85 2.91a.91.91 0 00-.47.59c-.23.78.51 1.31 1.31 1.63 1.66.67 4.56.78 6.68.78 3.93 0 7.61-1.46 7.9-6.26a6.28 6.28 0 00-5.95-6.17v-.03z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Customize.812145bc.svg";
export { SvgJ2Customize as ReactComponent };